import Assert from '@/helpers/assert';

const saveUploadedUsers = (localStorage, key) => (value) => {
  Assert.isPresent(key, 'key');
  Assert.isPresent(value, 'value');
  localStorage.setItem(key, JSON.stringify(value));
};

export default saveUploadedUsers;
